import { PrimaryButton } from "@fluentui/react/lib/Button";
import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";

interface Props {
  text: string;
  onClick?: () => any;
  baseTypeProps?: any;
}

const DeleteButton = (props: Props) => {
  return (
    <>
      <PrimaryButton
        text={props.text}
        onClick={props.onClick}
        {...props.baseTypeProps}
      >
        <Icon iconName="Delete" />
      </PrimaryButton>
    </>
  );
};

export default DeleteButton;
